import { IOException1wyutdmfe71nu as IOException } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/-PlatformJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ChannelIOExceptionClass;
function ChannelIOException() {
  if (ChannelIOExceptionClass === VOID) {
    class $ extends IOException() {}
    initMetadataForClass($, 'ChannelIOException');
    ChannelIOExceptionClass = $;
  }
  return ChannelIOExceptionClass;
}
//region block: exports
export {
  ChannelIOException as ChannelIOException2i3t76lsrbgox,
};
//endregion

//# sourceMappingURL=Channels.mjs.map
